module.exports = __webpack_public_path__ + "img/Bear40.73f0c4cb.jpg";